module.exports = "<app-maengelliste-view class=\"thisCont\"\n   [_maengelListe]=\"_maengelListe$ | async\">\n</app-maengelliste-view>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/maengel/compc/maengel-cont/maengel-cont.component.html
// module id = ../../../../../src/app/maengel/compc/maengel-cont/maengel-cont.component.html
// module chunks = main